import React, { useState } from 'react';
import './CheckoutForm.css';

const CheckoutForm = ({ cart, totalAmount, handleCheckout }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [zip, setZip] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('credit-card');

    const handleSubmit = (e) => {
        e.preventDefault();
        const orderDetails = {
            name,
            email,
            address,
            city,
            zip,
            paymentMethod,
            cart,
            totalAmount,
        };
        handleCheckout(orderDetails);
    };

    return (
        <form className="checkout-form" onSubmit={handleSubmit}>
            <h2 className="text-center mb-4">Checkout</h2>
            <div className="mb-3">
                <label htmlFor="name" className="form-label">Name</label>
                <input type="text" className="form-control" id="name" value={name} onChange={(e) => setName(e.target.value)} required />
            </div>
            <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input type="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="mb-3">
                <label htmlFor="address" className="form-label">Address</label>
                <input type="text" className="form-control" id="address" value={address} onChange={(e) => setAddress(e.target.value)} required />
            </div>
            <div className="mb-3">
                <label htmlFor="city" className="form-label">City</label>
                <input type="text" className="form-control" id="city" value={city} onChange={(e) => setCity(e.target.value)} required />
            </div>
            <div className="mb-3">
                <label htmlFor="zip" className="form-label">ZIP Code</label>
                <input type="text=" id="zip" value={zip} onChange={(e) => setZip(e.target.value)} required />
            </div>
            <div className="mb-3">
                <label className="form-label">Payment Method</label>
                <select className="form-select" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} required>
                    <option value="credit-card">Credit Card</option>
                    <option value="paypal">PayPal</option>
                    <option value="bank-transfer">Bank Transfer</option>
                </select>
            </div>
            <button type="submit" className="btn btn-primary w-100">Place Order</button>
        </form>
    );
};

export default CheckoutForm;